// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { BaseButton, BaseCard, BaseTypography, FormikField } from 'src/components/common';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { useCommonStyles } from 'src/materialConfig/commonStyles';
import { useHistory } from 'react-router';
import { useFetch } from 'src/utils/hooks/useFetch';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import appLogo from 'src/assets/images/app-logo.png';
import appIcon from 'src/assets/images/app-icon.png';
import BannerBG from 'src/assets/images/banner-bg.svg';
import sentMailImg from 'src/pages/ContactsPage/sent-mail.png';
import imgNew from '../img-new.png';
import bgImg from 'src/features/ContactUsFooter/bg.png';
import imgInterview from './Grow your Brand with PR.png';
import imgHowItWorks from './How it works.png';

import reuters from './Reuters.jpg';
import bbc from './BBC News.png';
import cnn from './CNN Business.jpg';
import marketwatch from './Marketwatch.jpg';
import times from './The Times.jpg';
import economic from './The Economic Times.jpg';
import telegraph from './The Telegraph.jpg';
import malay from './Malay Mail.jpg';
import edge from './The Edge Malaysia.png';
import sun from './The Sun.png';
import straits from './The Straits Times.png';
import businesstimes from './Business Times.png';
import mediacorp from './Mediacorp SG.jpg';

import { ModernTitle } from '../../../components/common/BaseTypography/ModernTitle';
import { useDeviceSizeType } from '../../../utils/hooks/useDeviceType';
import { landingValidationSchema } from './landingValidationSchema';
import { GoalsSelect } from 'src/components/fields/selects/GoalsSelect';
import { gtagApi } from 'src/api/base/Gtaglanging';
import { APP_ROUTES } from 'src/routing/AppRoutes';

import { BaseCarousel } from '../../../components/common/BaseCarousel/BaseCarousel';
import { CountBlockSection } from '../../../features/landing/countblock/countBlock';

const useStyles = makeStyles((theme) => ({
  form__titleWrapper: {
    marginBottom: '30px',
  },
  formGroup: {
    display: 'grid',
    gridGap: '25px',
  },
  formRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '40px',
    [theme.breakpoints.down('md')]: {
      gridGap: '28px',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  fieldsGroup: {
    marginTop: '8px',
    display: 'grid',
    gridAutoFlow: 'column',
    gridGap: '20px',
  },
  mainField: {
    display: 'grid',
	gridGap: '20px',
  },
  buttons: {
    margin: '45px 0',
  },
  cbutton: {
	color: 'white',
    border: '1px solid transparent',
    boxSizing: 'border-box',
    backgroundColor: '#0090E5',
	height: '45px',
    padding: '16px 20px',
    fontSize: '16px',
    transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontFamily: 'IBM Plex Sans',
    fontWeight: 'bold',
    lineHeight: '16px',
    borderRadius: '2px',
	marginTop: '20px',
	cursor: 'pointer',
	textDecoration: 'none',
	'&:hover': {
		border: '1px solid rgba(17, 17, 17, 0.12)',
		backgroundColor: '#00A0FF',
		boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
	},
	'&:disabled': {
	  backgroundColor: '#ccc',
	  color: '#666',
	  cursor: 'not-allowed',
	},
	'& .MuiCircularProgress-circle': {
		stroke: 'black !important',
	},
  },
  inputcontainer: {
	  display: 'grid',
      gridTemplateColumns: '50% 1fr',
      justifyContent: 'space-between',
	  gridGap: '15px',
	  '&#emailid': {
		flexBasis: '100%'
	  },
	  '&.MuiFormControl-root': {
		flexBasis: '100%'
	  },
		[theme.breakpoints.down('sm')]: {
		  gridTemplateColumns: '1fr',
		},
  },
  landingbannerinner: {
		backgroundColor: '#0000008F',
		position: 'absolute',
		width: '100%',
		height: '100%',
		top: '0',
		bottom: '0',
		left: '0',
		right: '0',
		zIndex: '-1',
	},
	landingbanner: {
		position: 'relative',
		zIndex: '0',
		textAlign: 'center',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
		padding: '120px 20px',
		'@media (max-width:480px)': {
			'& h1': {
				fontSize: '50px',
			},
		},
		'& form': {
			margin: '0 auto',
			textAlign: 'center',
		}
	},
	landingbannercontent: {
		maxWidth: '800px',
		margin: '0 auto',
	},
	landinglist: {
		'& li': {
			color: '#FFFFFF',
			fontSize: '18px',
			paddingLeft: '20px',
			paddingBottom: '10px',
		}
	},
	card: {
		textAlign: 'center',
		marginTop: '20px',
		padding: '62px 110px',
		[theme.breakpoints.down('md')]: {
		  padding: '20px',
		},
	},
	cardData: {
		display: 'grid',
		gridTemplateColumns: '480px 480px',
		gridGap: '30px',
		justifyContent: 'space-between',
		alignItems: 'center',
		[theme.breakpoints.down('md')]: {
		  gridTemplateColumns: '1fr 1fr',
		  justifyContent: 'center',
		  gridGap: '15px',
		},
		[theme.breakpoints.down('sm')]: {
		  gridTemplateColumns: '1fr',
		},
	},
	imgWrapper: {
		textAlign: 'center',
	  },
	img: {
		maxHeight: '460px',
		[theme.breakpoints.down('md')]: {
		  maxHeight: '160px',
		},
		[theme.breakpoints.down('sm')]: {
		  maxHeight: '200px',
		},
	},
	appLogo: {
		width: '120px',
	},
	footerroot: {
		background: `url(${bgImg})`,
		padding: '10px 0',
		backgroundSize: 'cover',
	},
	body: {
		display: 'grid',
		alignItems: 'center',
		gridTemplateColumns: 'max-content 730px',
		justifyContent: 'space-between',
		[theme.breakpoints.down('md')]: {
		  gridTemplateColumns: '1fr',
		},
	},
	gridWrapper: {
		padding: '40px 0px',
		alignItems: 'center',
		gap: '30px',
		flexWrap: 'nowrap',
		display: 'flex',
		[theme.breakpoints.down('md')]: {
		  padding: '0px',
		},
		[theme.breakpoints.down('sm')]: {
		  display: 'block',
		},
	},
	cardSlider: {
		textAlign: 'center',
		padding: '170px 110px',
		position: 'relative',
		zIndex: '0',
		[theme.breakpoints.down('md')]: {
		  padding: '50px 20px',
		},
	},
	articleDescription: {
		color: '#FFFFFF',
		maxWidth: '65%',
		margin: '20px auto',
		paddingBottom: '20px',
		'@media (max-width:767px)': {
			'&': {
				maxWidth: '80%', 
			},
		},
	},
	ulList: {
		marginLeft: '20px',
		marginTop: '0',
		'& li': {
			listStyle: 'disc',
			fontSize: '18px',
			marginBottom: '15px',
			listStyle: 'outside',
		},
		'& li::marker': {
			color: 'rgb(0, 144, 229)',
			fontSize: '20px'
		}
	},
	bannerTitle: {
		color: '#FFFFFF', 
		fontSize: '40px', 
		maxWidth: '70%', 
		margin: '0 auto',
		'@media (max-width:767px)': {
			'&': {
				fontSize: '25px',
				maxWidth: '100%', 
			},
		},
	},
	sectionTitle: {
		fontSize: '35px',
		fontWeight: '600',
		margin: '0 0 10px 0',
		'@media (max-width:767px)': {
			'&': {
				fontSize: '25px',
				margin: '20px 0 10px 0',
			},
		},
	}
}));


export const JournalistLandingPage: React.FC = (props) => {
  const { onSubmit, loading, errors } = props;
  const [{ response, isLoading, error }, doFetch] = useFetch<any, any>(
    gtagApi.freeConsultation,
  );
  const history = useHistory();
  const rowDirection = 'row';
  
  useEffect(() => {
    if (response) {
      history.push(APP_ROUTES.THANK_YOU);
    }
  }, [response, history]);
  
  const commonClasses = useCommonStyles();
  const classes = useStyles();
  
  const formik = useFormik({
    initialValues: {
      first_name: '',
      last_name: '',
	  email: '',
	  professional_title: '',
	  linkedin_profile: '',
	  phone_number: '',
	  goals: '',
	  where_we_learn: '',
    },
	validationSchema: landingValidationSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
		doFetch(values);
      formik.setErrors({});
    },
  });
  
  const { setFieldError } = formik;
  
  const { isDesktop } = useDeviceSizeType();
  
   const title = (
    <div style={{ textAlign: 'center', margin: '40px 0' }}>
      <span>Book Your</span>
      <span className="primary"> Free Consultation Today</span>
    </div>
  );
  
  const communitytitle = (
    <div style={{ textAlign: 'center', margin: '40px 0' }}>
      <span className="primary">Join our </span>
      <span>growing community!</span>
    </div>
  );
  
   const settings = {
    autoplay: true,
    dots: true,
    infinite: true,
    arrows: true,
    speed: 200,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      },
    ],
  };
  
  return (
	
	<div id="journalist-container">
		<div id="journalist-banner">
			<BaseCarousel>
				<>
				  <div className={classes.cardSlider} style={{ backgroundImage: `url(${BannerBG})`, backgroundRepeat: 'no-repeat', backgroundPosition:'center bottom', backgroundSize: 'cover'}}>
					<div className={classes.landingbannerinner}> </div>
					<Grid
					  direction={rowDirection}
					  container
					  className={classes.card__sectrion}>
					  <Grid
						item
						xs={12}
						className={classes.card__articleSection}>
						<BaseTypography className={classes.bannerTitle} variant="text">
						  Get Discovered by Journalists, Podcasters & Event Organisers Across Asia 
						</BaseTypography>
						<BaseTypography
							variant="text"
							className={classes.articleDescription}
							dangerouslySetInnerHTML={{ __html : "Build your reputation as a trusted expert. We connect professionals like you with verified media looking for credible voices — for interviews, speaking engagements and stories that matter"}}
						/>
						<BaseTypography variant="tag" className="pointer">
						  <a className={classes.cbutton} href="#free-consultaion">
							Book your free consultation
						  </a>
						</BaseTypography>
					  </Grid>
					</Grid>
				  </div>
				</>
				<>
				  <div className={classes.cardSlider} style={{ backgroundImage: `url(${BannerBG})`, backgroundRepeat: 'no-repeat', backgroundPosition:'center bottom', backgroundSize: 'cover'}}>
					<div className={classes.landingbannerinner}> </div>
					<Grid
					  direction={rowDirection}
					  container
					  className={classes.card__sectrion}>
					  <Grid
						item
						xs={12}
						className={classes.card__articleSection}>
						<BaseTypography className={classes.bannerTitle} variant="text">
						  Get Discovered by Journalists, Podcasters & Event Organisers Across Asia 
						</BaseTypography>
						<BaseTypography
							variant="text"
							className={classes.articleDescription}
							dangerouslySetInnerHTML={{ __html : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley."}}
						/>
						<BaseTypography variant="tag" className="pointer">
						  <a className={classes.cbutton} href="#free-consultaion">
							Book your free consultation
						  </a>
						</BaseTypography>
					  </Grid>
					</Grid>
				  </div>
				</>
			</BaseCarousel>
		</div>
		<div className={clsx(commonClasses.container)}>
			<div id="logo-carousel">
				<Slider {...settings}>
				  <img src={reuters} alt="Reuters" />
				  <img src={sun} alt="The Sun" />
				  <img src={bbc} alt="BBC News" />
				  <img src={times} alt="The Times" />
				  <img src={marketwatch} alt="Marketwatch" />
				  <img src={mediacorp} alt="Mediacorp SG" />
				  <img src={straits} alt="The Straits Times" />
				  <img src={economic} alt="The Economic Times" />
				  <img src={telegraph} alt="The Telegraph" />
				  <img src={businesstimes} alt="Business Times" />
				  <img src={edge} alt="The Edge Malaysia" />
				  <img src={cnn} alt="CNN Business" />
				  <img src={malay} alt="Malay Mail" />
				</Slider>
			</div>
		</div>
		
		<div className={clsx(commonClasses.container)}>
			<Grid spacing={10} className={clsx(classes.gridWrapper)}>
				<Grid item md={6} xs={12}>
				  <img src={imgInterview} style={{ maxWidth: '100%' }} alt="Right" />
				</Grid>				
				<Grid item md={6} xs={12} style={{ padding: 0 }}>
				  <h2 className={clsx(classes.sectionTitle)}>Grow your Brand with PR</h2>
				  <BaseTypography variant="text" style={{ fontSize: '18px', marginBottom: '10px' }}> ContactsBook.Asia is a platform that bridges the gap between experts and journalists across Asia. Whether Your are a business leader, author, doctor or activist, we help you to gain credible media exposure through interviews, podcasts, and thought leadership features. Journalists use our platform to find the right experts fast, while experts like you get to build visibility, trust, and reputation in your industry.</BaseTypography>
				  <BaseTypography variant="text" style={{ fontSize: '18px', marginTop: '10px' }}>Can we help you get the right recognition? <a href="#free-consultaion">Contact us for a free consultation!</a></BaseTypography>
				</Grid>
				
			</Grid>
		</div>
		
		<section className={commonClasses.container} style={{ marginBottom: '20px' }}>
		  <BaseTypography style={{ fontWeight: 700, color: '#000000', fontSize: '32px', textAlign: 'center' }}>
			<ModernTitle title={communitytitle} />
		  </BaseTypography>
		  <CountBlockSection />
		</section>
		
		<div className={clsx(commonClasses.container)}>
			<Grid spacing={10} className={clsx(classes.gridWrapper)}>
				<Grid item md={6} xs={12} style={{ padding: 0 }}>
				  <h2 className={clsx(classes.sectionTitle)}>How it works</h2>
				  <BaseTypography variant="text" style={{ fontSize: '18px', marginBottom: '10px' }}> 
					<ul className={clsx(classes.ulList)}>
						<li>Introduction
						We list you as a verified subject-matter expert on our platform and introduce you to 2,000+ journalists across Asia and beyond, giving you instant visibility from day one.</li>
						
						<li>Preparation
						We assess your media potential and equip you with everything you need to shine: messaging workshops, professionally crafted content, and videos that showcase your expertise with authority.</li>

						<li>Promotion
						Once you’re ready, we amplify your presence through targeted media mentions, guaranteed exposure on our platform, social promotion, speaking opportunities, and ongoing media monitoring. We even pitch you directly to journalists and nominate you for awards so you’re not just visible, you’re influential.</li>
					</ul>
				  </BaseTypography>
				</Grid>
				<Grid item md={6} xs={12}>
				  <img src={imgHowItWorks} style={{ maxWidth: '100%' }} alt="Right" />
				</Grid>
			</Grid>
		</div>
		
		<div className={clsx(commonClasses.container)} style={{ marginBottom: '50px' }} id="free-consultaion">
			<ModernTitle title={title} />
			<BaseCard className={classes.card}>
				<div className={clsx(classes.cardData)}>
				  <div>
					<div className={classes.imgWrapper}>
					  <img src={sentMailImg} alt="Sent Mail" className={classes.img} />
					</div>
				  </div>
				  <form onSubmit={formik.handleSubmit} className={classes.fieldsGroup}>
						<div className={classes.mainField}>
						  <div className={classes.formRow}>
							<FormikField
								label="First name*"
								placeholder="Please enter your input"
								name="first_name"
								formik={formik}
							/>
							<FormikField
								label="Last name*"
								placeholder="Please enter your input"
								name="last_name"
								formik={formik}
							/>
						  </div>
						  <FormikField
							label="Email address*"
							placeholder="example@mail.com"
							name="email"
							formik={formik}
						  />
						  <FormikField
							label="Professional title*"
							placeholder="Please enter your input"
							name="professional_title"
							formik={formik}
						  />
						  <FormikField
							label="Linkedin profile (if you have one)"
							placeholder="Please enter your input"
							name="linkedin_profile"
							formik={formik}
						  />
						  <FormikField
							label="Phone number"
							placeholder="Please enter your input"
							name="phone_number"
							formik={formik}
						  />
						  <FormikField
							label="What are your goals?"
							name="goals"
							formik={formik}
							inputComponent={GoalsSelect}
							onChange={(newValue: string) => {
							  formik.setFieldValue('goals', newValue);
							}}
						  />
						  <FormikField
							label="Where can we learn about you? (Website, Linkedin, Social media etc)"
							placeholder="Please enter your input"
							name="where_we_learn"
							formik={formik}
						  />
						  <BaseButton
							className={classes.submitBtn}
							loading={loading}
							color="primary"
							variant="contained"
							size="large"
							type="submit">
							Claim your Free Consultation
						  </BaseButton>
						</div>
					</form>
				</div>
			</BaseCard>
		</div>
    </div>
  )
}